<template>
  <b-modal
    id="paymentStoryModal"
    v-model="showPaymentModal"
    size="lg"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    dialog-class="story-modal-dialog"
    :key="modalKey"
  >
    <div class="story-modal">

      <div class="story-progress header">
        <span
          v-for="(s, i) in slides"
          :key="i"
          :class="['story-bar mx-2', { active: i <= currentIndex }]"
          @click="goToSlide(i)"
          style="cursor: pointer;"
        ></span>

         <img
            v-if="!isLastSlide"
            src="@/assets/images/arrow-right.svg"
            alt="Suivant"
            class="story-next mt-sm-0 mt-4"
            @click="goToSlide(currentIndex + 1)"
          />

      </div>

      <div>
        <h5 v-if="currentIndex > 0" :class="currentSlide.class" class="text-center font-weight-bold mt-5 font-size-24 text-uppercase">
          {{ currentSlide.title }}
        </h5>
      </div>

      <div
            class="skip-btn"
            v-if="currentIndex != 5"
            @click="skipIntro"
        >
            Passer
      </div>

      <div class="story-modal-body">

        <div v-if="currentIndex === 0" class="story-header intro-slide">

          <div
            v-if="introStep >= 1"
            :class="[
              'logo-container',
              introStep === 1 ? 'animate-appear' : '',
              introStep === 2 ? 'animate-zoom' : ''
            ]"
          >
            <img src="@/assets/images/logo.png" height="180" />

            <h5
              v-if="introStep === 1"
              class="intro-subtitle text-white text-uppercase mt-3 font-size-24"
              :class="currentSlide.class"
            >
              {{ currentSlide.title }}
            </h5>
          </div>

        </div>

        <transition name="fade" mode="out-in">
          <div
            :key="currentIndex"
            class="story-body d-flex flex-column justify-content-center align-items-center text-center text-uppercase font-weight-bold"
            style="letter-spacing: 0.9px; height: 100%;"
          >
            <div
              v-for="(line, index) in currentSlide.content"
              :key="index"
              class="story-line my-3 slide-up"
              :style="{ 'animation-delay': `${index * 0.25}s` }"
            >
              <span v-if="line.key && line.type != 1" class="story-counter"  :class="line.class" >
                <countTo
                  class="mt-2"
                  style="font-size:40px; font-weight:600;"
                  :autoplay="true"
                  separator=" "
                  :startVal="0"
                  :endVal="stats[line.key]"
                  :decimals="line.decimals || 0"
                  :duration="stats[line.duration]"
                  :formatter="formatDecimal"
                ></countTo>
                <span>{{ line.unit }}</span>
              </span>

              <div class="font-size-18" :class="line.class">

                {{ line.type == 1 ? (stats[line.key] + " ") : '' }}{{ line.text }}
              </div>

              <div v-if="isLastSlide" class="text-center">
                <div class="d-flex justify-content-center gap-3 flex-wrap">
                  <div class="final-cta r-md-3 mr-0" @click="goToPayment">
                    <i class="fas fa-credit-card"></i>
                    Renouveler maintenant
                  </div>

                  <div class="final-cta-cancel ml-md-3 ml-0" @click="closeModal">
                    <i class="fas fa-clock"></i>
                    Plus tard
                  </div>
                </div>
              </div>

            </div>
          </div>
        </transition>

      </div>
    </div>
  </b-modal>
</template>

<script>
import countTo from 'vue-count-to';
import { mapState } from 'vuex';
import OrdersApi from "@/services/orders-api";

export default {
  components: { countTo },

  data() {
    return {
      introStep: 0,
      currentIndex: 0,
      autoTimer: null,
      modalKey: 0,
      stats: {},
      introTimeouts: [],
      slides: [
        {
          title: 'Bonne année !' ,class:"text-primary",
        },
        {
          title: '',
          content: [
            { text: 'Nous vous souhaitons une année pleine de santé, de réussite et de prospérité.',class:"text-primary" },
            { text: 'Merci pour votre confiance.',class:"text-success" },
            { text: 'Votre participation permet à l’ensemble du groupement de grandir et d’obtenir de meilleures conditions commerciales',class:"text-primary" }
          ]
        },
        {
          title: 'Récapitulons ensemble l\'année' ,class:"text-success",
          content: [
            { text: 'commandes passées', key: 'orderCount', duration:100, class:"text-primary" },
            { text: 'commandé', key: 'totalOrdered', duration:2500 , unit:"TND", class:"text-primary"  },
            { text: 'économisé', key: 'totalSavings', duration:2500 , unit:"TND", class:"text-primary"  },
            { text: 'Remise moyenne', key: 'avgDiscount' , duration:50, unit:"%", class:"text-primary"  }
          ]
        },
        {
          title: 'Le groupement en ' ,class:"text-success",
          content: [
            { text: 'pharmacies membres', key: 'customerCount', class:"text-primary" },
            { text: 'croissance',  key: 'growth' , duration: 100, unit:"%", class:"text-primary" },
            { text: 'nouveaux partenaires', key: 'newPartner' , duration: 100, class:"text-primary" },
            { text: 'achats consolidés', key: 'consolidatedPurchases' , duration: 100 , unit:"M TND", class:"text-primary", decimals:1  }
          ]
        },
        {
          title: 'Encore plus avantageux' ,class:"text-success" ,
          content: [
            { text: '3 Nouveaux fournisseurs en négociation', class:"text-primary" },
            { text: 'Plus d’offres groupées', class:"text-primary"  },
            { text: 'Plateforme améliorée', class:"text-primary"  },
            { text: 'Accompagnement plus personnalisé', class:"text-primary"  }
          ]
        },
        {
          title: '',
          content: [
            { text: 'Renouvelez votre adhésion en deux clic', class:"text-primary" }
          ]
        }
      ]
    }
  },

  mounted() {
    if(this.showPaymentModal){
        this.getPreviousYearReporting()
        this.startIntroSequence()
    }
  },

  beforeUnmount() {
    clearInterval(this.autoTimer)
    this.clearIntroTimeouts()
  },

  computed: {
    ...mapState({
      showPaymentModal: state => state.auth.showPaymentModal,
      paymentData: state => state.auth.paymentData
    }),
    currentSlide() {
      return this.slides[this.currentIndex]
    },
    isLastSlide() {
      return this.currentIndex === this.slides.length - 1
    }
  },

  watch: {
    showPaymentModal(val) {
        if (val) {
            this.getPreviousYearReporting()
            this.startIntroSequence()
        }
    }
  },
  methods: {

    skipIntro(){
        this.currentIndex = 5
    },
    startIntroSequence() {
      this.clearIntroTimeouts()
      clearInterval(this.autoTimer)
      this.autoTimer = null

      this.currentIndex = 0
      this.introStep = 0

      this.introTimeouts.push(
        setTimeout(() => { this.introStep = 1 }, 800)
      )

      this.introTimeouts.push(
        setTimeout(() => { this.introStep = 2 }, 3800)
      )

      this.introTimeouts.push(
        setTimeout(() => {
          this.currentIndex = 1
          this.startAutoSlide()
        }, 5600)
      )
    },


    clearIntroTimeouts() {
      this.introTimeouts.forEach(t => clearTimeout(t))
      this.introTimeouts = []
    },

    getPreviousYearReporting(){
        OrdersApi.getPreviousYearReporting().then((result) => { 
          this.stats = result 

          const year = this.stats.currentYear;
          this.slides[0].title = `Bonne année ${year} !`;
          this.slides[2].title = `Récapitulons ensemble l'année ${year - 1}`;
          this.slides[3].title = `Le groupement en ${year - 1}`;
          this.slides[4].title = `${year} Encore plus avantageux`;
        
        })
    },

    formatDecimal(value) {
        return value.toFixed(2).replace('.', ',');
    },

    startAutoSlide() {
      clearInterval(this.autoTimer)
      this.autoTimer = setInterval(() => {
        if (!this.isLastSlide) {
          this.currentIndex++
        } else {
          clearInterval(this.autoTimer)
          this.autoTimer = null
        }
      }, 11000)
    },

    goToSlide(index) {
      this.clearIntroTimeouts()
      clearInterval(this.autoTimer)

      this.currentIndex = index
      if(index == 0){
        this.introStep = 0; 
        this.startIntroSequence() 
      }else {
         this.startAutoSlide() 
        }
    },

    closeModal() { this.$store.dispatch('auth/hidePaymentModal') },

    goToPayment() {
      this.closeModal()
      if (this.$route.path !== '/payment') this.$router.push('/payment')
    }
  }
}
</script>
<style scoped>

.story-header {
  align-items: center;
  text-align: center;
}


.story-modal-body{
  height: 100%;
  min-height: 30em;
  align-content: center;
}

@media (max-width: 576px) {
  .story-modal-body {
    min-height: 47em;
  }
}

::v-deep .modal-content {
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 28px;
  color: #fff;
  background: #f8f9faa9;
  backdrop-filter: blur(20px);
  border: 1px solid #1F3A56;
  box-shadow: 0 25px 60px rgba(0,0,0,0.25);
}

::v-deep .modal-content::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 28px;
  background: radial-gradient(circle at 50% 50%, #f8f9fa, transparent 70%);
  pointer-events: none;
}

::v-deep .modal-content::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.7' numOctaves='2' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.03'/%3E%3C/svg%3E");
  mix-blend-mode: soft-light;
  pointer-events: none;
}

.story-progress {
  justify-content: center;
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
}
.story-next {
  position: absolute;
  height: 15px;
  right: 0;
  cursor: pointer;
  margin-right: 10px;
}

.story-bar {
  max-width: 40px;
  flex: 1;
  height: 4px;
  background: rgba(255,255,255,0.15);
  border-radius: 10px;
  transition: all 0.4s ease;
}

.story-bar.active {
  background: linear-gradient(90deg, #1F3A56, #2A4B7C);
  animation: fillBar 0.8s forwards;
}

@keyframes fillBar {
  0% { width: 0%; }
  100% { width: 100%; }
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.5s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }

.slide-up {
  animation: slideUp 1.3s cubic-bezier(.22,1,.36,1) both;
}

@keyframes slideUp {
  0% { opacity: 0; transform: translateY(140px) scale(0.95); filter: blur(6px); }
  70% { opacity: 1; transform: translateY(-8px) scale(1.02); filter: blur(0); }
  100% { transform: translateY(0) scale(1); }
}

.animate-recap { animation: recapIn 1.2s cubic-bezier(.16,1,.3,1) both; }
@keyframes recapIn {
  from { opacity:0; transform: scale(.85) translateY(18px); filter: blur(6px); }
  to { opacity:1; transform: scale(1) translateY(0); filter: blur(0); }
}

.animate-appear { animation: logoIn 1.4s cubic-bezier(.22,1,.36,1) both; }
@keyframes logoIn {
  from { opacity:0; transform: scale(.8); filter: blur(8px); }
  to { opacity:1; transform: scale(1); filter: blur(0); }
}

.animate-zoom {
  animation: heroZoomFancy 4s cubic-bezier(.22,1,.36,1) both;
}

@keyframes heroZoomFancy {
  0% {
    transform: scale(1);
    filter: blur(0px);
    opacity: 1;
  }
  50% {
    transform: scale(3);
    filter: blur(4px);
    opacity: 0.95;
  }
  100% {
    transform: scale(5.6);
    filter: blur(8px);
    opacity: 0.9;
  }
}

.story-counter { 
  font-size:2.5rem; 
  font-weight:700; 
  text-shadow:0 0 3px #f5f5f5 !important; 
}

.final-cta {
  margin-top: 22px;
  padding: 12px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(70deg, #1F3A56, #297a54);
  background-size: 200% 200%;
  animation: gradientShift 3s ease infinite;
  border-radius: 999px;
  box-shadow: 0 12px 30px rgba(31,58,86,0.45);
  transition: all 0.3s ease;
  
}
.final-cta:hover { transform: translateY(-2px) scale(1.05); box-shadow:0 18px 40px rgba(31,58,86,0.6); }

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.final-cta-cancel {
  margin-top: 22px;
  padding: 12px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #1F3A56;
  background: transparent;
  border: 2px solid #f9f9fc;
  border-radius: 999px;
  transition: all 0.25s ease;
}
.final-cta-cancel:hover { color:#ffffff; border-color:#f9f9fc; background: rgba(31,58,86,0.3); }



.skip-btn {
  position: absolute;
  bottom: 18px;
  right: 20px;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #2A4B7C;
  cursor: pointer;
  z-index: 5;

}

</style>
